import React, { useState, useEffect } from "react";
import "./EditUserForm.css"; // Import CSS for styling

const EditUserForm = ({ user, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    first_name: user.first_name,
    last_name: user.last_name,
    email: user.email,
    phone: user.phone,
    role_id: user.role_id, // Store membership_id instead of tier name
  });

  const [roleOptions, setRoleOptions] = useState([]);

  // Fetch membership options from backend
  useEffect(() => {
    fetch("/api/roles")
      .then((response) => response.json())
      .then((data) => setRoleOptions(data))
      .catch((error) => console.error("Error fetching role options:", error));
  }, []);

  // Handle input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Submit updated data
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`/api/admin/update-user/${user.user_id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error("Failed to update user.");
      }

      const updatedUser = { ...user, ...formData };

      onSave(updatedUser); // Update parent state & refresh list
      onClose(); // Close modal
    } catch (error) {
      console.error("Error updating user:", error);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content1">
        <button className="close-button" onClick={onClose}>✖</button>
        <h3>Edit User</h3>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
          <label id="add-user-label">First Name:</label>
          <input type="text" id='edit-user-firstname' name="first_name" value={formData.first_name} onChange={handleChange} required />
          </div>

          <div className="form-group">
          <label id="add-user-label">Last Name:</label>
          <input type="text" id='edit-user-firstname' name="last_name" value={formData.last_name} onChange={handleChange} required />
          </div>

          <div className="form-group">
          <label id="add-user-label">Email:</label>
          <input type="email" id='edit-user-firstname' name="email" value={formData.email} onChange={handleChange} required />
          </div>

          <div className="form-group">
          <label id="add-user-label">Phone:</label>
          <input type="text" id='edit-user-firstname' name="phone" value={formData.phone} onChange={handleChange} required />
          </div>

          <div className="form-group">
          <label id="add-user-label">Access Level:</label>
          <select name="role_id" id='edit-user-firstname' value={formData.role_id} onChange={handleChange} required>
            {roleOptions.map((role) => (
              <option key={role.role_id} value={role.role_id}>
                {role.role_name}
              </option>
            ))}
          </select>
          </div>

          <button type="submit" className="save-button">Save Changes</button>
        </form>
      </div>
    </div>
  );
};

export default EditUserForm;
